
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Styles from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/LeadInquiriesView.module.scss";
import { ActiveInquiryViewsEnum } from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/ActiveInquiryViewsEnum";
import { MatchedNewLeadCard } from './MatchedNewLeadCard' ; 
import { LeadTypeIdEnum } from '../../../../../Enums' ; 

export const UnitMatchingWithLeadsCardsComponent = ({
  parentTranslationPath,
  translationPath,
  data,
  totalCount,
  saleMatching,
  activeLead , 
  setActiveLead ,
  setActiveView ,
  activeView ,
  unitInfo ,
  activeItem , 
  isSmartProposalActive ,
  setCheckedDetailedCards ,
  getIsSelectedCard ,
  onCardCheckboxClick
}) => {

  const { t } = useTranslation(parentTranslationPath);

  const viewChangeHandler = useCallback(({ view, lead  } , action) => {
    setActiveLead(lead || null);
    if (!action) {
      setActiveView(view);
    }
    if (action && action?.clickAction === "viewLead") {
      {
        window.open(
          `/home/leads/lead-profile-edit?formType=${LeadTypeIdEnum.Seeker.leadTypeId}&&id=${
            lead.leadId
          }&leadClass=${lead?.leadData?.leadClassName}&leadStatus=Open`,
          "_blank"
        );
      }
    }
  }, []);

  return (
    <>
      <div className={`${Styles.Heading_box} mx-3 mb-4`}>
        <div className={Styles.Heading}>
          {activeView !== ActiveInquiryViewsEnum.UnitOverview && (
            <h3
              onClick={() =>
                viewChangeHandler({
                  view: ActiveInquiryViewsEnum.MatchedUnit,
                })
              }
            >
              {t(`matching-leads`)}
              {totalCount ? ` = ${totalCount}` : "0"}
            </h3>
          )}
          {activeView == ActiveInquiryViewsEnum.UnitOverview ? (
            <>
              <span className={`mdi mdi-page-last mt-1 mx-2`}  onClick={() =>
                viewChangeHandler({
                  view: ActiveInquiryViewsEnum.MatchedUnit ,

                })
              }></span>
              <h4>
                <span>{activeLead?.lead?.property?.name || null}</span>
                <span className="mx-2">
                  {activeLead?.lead?.property?.name
                    ? `( ${activeLead?.lead?.property?.name} )`
                    : "overview"}
                </span>
              </h4>
            </>
          ) : null}
        </div>
      </div>
      {activeView === ActiveInquiryViewsEnum.MatchedUnit ? (
        <div className="units-cards-wrapper d-flex m-3 flex-wrap gap-16">
          {data?.result &&
            data.result.map((item , index) =>
              item ? (
                <MatchedNewLeadCard
                  key={item?.leadId}
                  data={item}
                   actionButtons={{
                    sendPropsal: true,
                    viewLead: true,
                    sendSmartPropsal : true , 
                  }}
                  viewLeadHandler={(clickAction) =>
                    viewChangeHandler({
                      view: ActiveInquiryViewsEnum.UnitOverview,
                      lead: item,
                    }, clickAction)
                  }
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  isLease={!saleMatching}
                  unitInfo={unitInfo}
                  activeLead={activeLead}
                  activeItem={activeItem}
                  isSmartProposalActive={isSmartProposalActive}
                  setCheckedDetailedCards={setCheckedDetailedCards}
                  getIsSelectedCard={getIsSelectedCard}
                  index={index}
                  onCardCheckboxClick={onCardCheckboxClick}
                />
              ) : null
            )}
        </div>
      ) : null}
    </>
  );
};
